import {Component} from '@angular/core';
import {NavParams, ViewController, AlertController, NavController, Keyboard} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {AppDialog} from "../../component/appDialog";
import {AgentPEListPage} from "../agentPEList/agentPEList";

//投注详情
@Component({
  templateUrl: 'agentPE.html',
  selector: 'agent-p-e-page',
})
export class AgentPEPage {
  private selectAction: string = "action1";
  private lname: string = "";
  private areaValue: number = 0;
  private fdValue: string;
  private personList: any = [];
  private teamList: any = [];
  private fdList: any = [];
  private hasSearch: boolean = true;

  constructor(private keyboard: Keyboard,private nav: NavController, public params: NavParams, public viewCtrl: ViewController, private userService: UserService, private alertCtrl: AlertController) {
    let data = params.get("lname");
    if (data) {
      this.hasSearch = false;
      this.subService(data);
    } else {
      this.initService();
    }
  }

  searchFn() {
    let postData = {
      lname: this.lname,
      areavalue: this.areaValue,
      fdvalue: this.fdValue
    };
    this.userService.agentPEBeanSearch(postData, this.alertCtrl).then(data=> {
      if (!data["msg"]) {
        this.nav.push(AgentPEListPage, {
          data: data,
          requestData: postData
        });
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

  initService() {
    this.userService.agentPEBeanInit(undefined, this.alertCtrl).then(data=> {
      if (!data["msg"]) {
        this.personList = data["personlist"];
        this.teamList = data["teamlist"];
        this.fdList = data["fdlist"];
        this.fdValue = ((data["fdlist"][0] !== null) && (data["fdlist"][0] !== undefined)) ? data["fdlist"][0]["value"] : '';
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

  /**
   * 子集查询服务
   * @param lname
   */
  subService(lname: string) {
    let postData = {
      lname: lname
    };
    this.userService.agentPESub(postData, this.alertCtrl).then(data=> {
      if (!data["msg"]) {
        this.personList = data["vpersonlist"];
        this.teamList = data["vteamlist"];
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

  ionViewWillLeave(){
    this.keyboard.close();
  }
}



// WEBPACK FOOTER //
// ./src/pages/agentPE/agentPE.ts